import React from 'react';
import loader from './assets/loader.gif';

import './loader.css';

class Loader extends React.Component {

    render(){
        return (
            <div className="loader row justify-content-center">
                <img src={loader} alt="loading" />
            </div>
        )
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/generic/Loader.jsx